/**
 * See [turn4api.yaml](https://gitlab.com/lotlinx/core/turn4-api/-/blob/dev/src/main/resources/spec/turn4api.yaml)
 * for details
 * */
export enum ErrorCode {
  // Legacy codes (keep for backward compat until fully migrated)
  SYSTEM_ERROR = '-1',
  INVALID_REQUEST = '-2',
  NO_METHOD_SPECIFIED = '-3',
  INVALID_METHOD = '-4',
  PARAMETER_ERROR = '-5',
  ACCESS_DENIED = '-100',
  NO_DATA_AVAILABLE = '-200',

  // New standardized codes
  MISSING_PARAM = 'MISSING_PARAM',
  INVALID_PARAM = 'INVALID_PARAM',
  DEALER_INVALID = 'DEALER_INVALID',
  DEALER_ACCESS_DENIED = 'DEALER_ACCESS_DENIED',
  ACCOUNT_ACCESS_DENIED = 'ACCOUNT_ACCESS_DENIED',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  RATE_LIMITED = 'RATE_LIMITED',
  UPSTREAM_UNAVAILABLE = 'UPSTREAM_UNAVAILABLE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
